import { isObservable } from "../Observable/mod.js";
/**
 * @internal scope: workspace
 */
export class ChainLink {
    #value;
    constructor(value) {
        this.#value = value;
    }
    debug(label) {
        console.debug(label, this.#value);
        return new ChainLink(this.#value);
    }
    fallback(defaultValue) {
        return new ChainLink(this.#value ?? defaultValue);
    }
    map(transform) {
        return new ChainLink(transform(this.#value));
    }
    tap(callback) {
        callback(this.#value);
        return new ChainLink(this.#value);
    }
    get() {
        return this.#value;
    }
    subscribe(subscriber) {
        if (!isObservable(this.#value)) {
            throw new Error("Cannot subscribe to a non-observable value");
        }
        this.#value.subscribe(subscriber);
        return new ChainLink(this.#value);
    }
}
/**
 * Creates a chainable link that allows for transformations and retrieval of a value
 *
 * @beta This API is in beta and may change in future releases.
 */
export function chain(value) {
    return new ChainLink(value);
}
